import React from "react";

export default function SensibilidadeProdutos() {
    return (
        <div className="Containt">SENSIBILIDADE E PRODUTOS</div>
    )
}